module.exports = __webpack_public_path__ + "img/c8.3dbe8fcf.png";